import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=cc1f94fe&scoped=true&component=true&componentId=index14f180f0"
import script from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index14f180f0"
export * from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index14f180f0"
import style0 from "./index.mpx?vue&type=style&index=0&id=cc1f94fe&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m14f180f0%22%7D&component=true&componentId=index14f180f0"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1f94fe",
  null
  
)

export default component.exports